const TableRow = ( { label, value } ) => {
	return (
		<tr>
			<td>
				<strong>{ label }</strong>
			</td>
			<td>{ value }</td>
		</tr>
	);
};

export default TableRow;
